import { useContext, useId } from "react";

import { SxProps } from "@mui/material";
import { DonationFormCategory, FormType } from "@simplyk/common";

import { FrontendFormContext } from "../../../../../common/contexts/FrontendFormContext";
import { useFormV2Context } from "../../contexts/FormV2Context";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormCheckbox } from "@/forms-design-system/FormCheckbox";

type PublicDonationCheckboxProps = {
  sx?: SxProps;
};

export const PublicDonationCheckbox = ({ sx }: PublicDonationCheckboxProps) => {
  const { form } = useFormV2Context(FormType.DonationForm);
  const { t } = useTranslate();

  return (
    <FormCheckbox
      control={form.control}
      name="isPublicDonation"
      id={useId()}
      label={t("donationForm", "isPublicDonation")}
      defaultChecked={true}
      sx={sx}
    />
  );
};

export const usePublicDonationCheckboxRenderPosition = () => {
  const { type, formObject } = useFormV2Context();
  const { displayExpressCheckout, category } = useContext(FrontendFormContext);

  if (type !== FormType.DonationForm) {
    return null;
  }

  if (category === DonationFormCategory.DonationForm && !formObject.displayDonorList) {
    return null;
  }

  return displayExpressCheckout ? "summary-section" : "your-information-section";
};
